export const BUY_COLOR = '#007D7C';
export const BUY_BACKGROUND_COLOR = '#D9FBFC';

export const SELL_COLOR = '#C2377F';
export const SELL_BACKGROUND_COLOR = '#FFF0F8';
